import { useNavegacion } from './navegacionReact';

// EL AVISO DE LA RAÍZ · TC-DR-AT. En «Mi trabajo», el primer atrás no
// saca de TEGO: enseña esto durante dos segundos, que es la ventana en la
// que un segundo atrás sí sale. Igual que las aplicaciones de Android.
//
// `pointer-events-none`: no puede tapar un botón (invariante móvil M6).
// Sin icono y sin botón: no hay nada que tocar, solo que leer.
export default function AvisoDeSalida({ visible }) {
  const { aviso } = useNavegacion();
  if (!(visible ?? aviso)) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-x-0 bottom-20 z-50 flex justify-center px-4 pointer-events-none"
    >
      <p className="max-w-full rounded-full bg-gray-900 px-4 py-2 text-center text-sm font-semibold text-white shadow-lg">
        Pulsa atrás otra vez para salir de TEGO
      </p>
    </div>
  );
}
